import axios from "axios";
import { removeNullFields } from "./utils";

const setupInterceptors = (navigate, ctxDispatch, userInfo) => {
  var client = userInfo?.isHelpDesk
    ? axios.create({
        headers: {
          Authorization: `Bearer ${userInfo?.client?.token || userInfo?.token}`,
        },
      })
    : axios.create({
        headers: { Authorization: `Bearer ${userInfo?.token}` },
      });

  client.interceptors.request.use(
    (config) => {
      if (userInfo && userInfo.isHelpDesk && !userInfo.client) {
        throw new Error("Bu işlemi şu anda gerçekleştiremezsiniz!");
      }

      // Skip processing for URLs that match the pattern `/api/upload/%`
      const uploadUrlPattern = /^\/api\/upload\/.*/; // Matches '/api/upload/' followed by anything
      if (uploadUrlPattern.test(config.url)) {
        return config; // Skip further processing
      }

      if (config.data && typeof config.data === "object") {
        // Remove null fields from the request payload
        config.data = removeNullFields(config.data);
      }

      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );

  client.interceptors.response.use(
    function (response) {
      return response;
    },
    function (error) {
      if (error?.response?.status === 401) {
        ctxDispatch({ type: "USER_SIGNOUT" });
        localStorage.removeItem("userInfo");
        navigate("/signin");
        return Promise.reject({
          message:
            "Oturumunuz zaman asimina ugradi. Lutfen yeniden giris yapiniz",
        });
      } else if (
        error?.response?.status === 403 &&
        error?.response?.data &&
        error?.response?.data.message === "Üyeliğinizin süresi dolmuştur"
      ) {
        navigate("/profile?active=membership");

        return Promise.reject({
          status: 403,
          message:
            "Üyeliğinizin süresi dolmuştur, lütfen yeni üyelik satın alınız",
        });
      }

      return Promise.reject(error);
    }
  );

  return client;
};

export default setupInterceptors;
